var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.25C7.92893 3.25 6.25 4.92893 6.25 7C6.25 9.07107 7.92893 10.75 10 10.75C12.0711 10.75 13.75 9.07107 13.75 7C13.75 4.92893 12.0711 3.25 10 3.25ZM7.75 7C7.75 5.75736 8.75736 4.75 10 4.75C11.2426 4.75 12.25 5.75736 12.25 7C12.25 8.24264 11.2426 9.25 10 9.25C8.75736 9.25 7.75 8.24264 7.75 7Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 0.25C7.96326 0.25 6.11832 1.14624 4.63728 2.21178C3.15032 3.28159 1.96564 4.56824 1.23323 5.45747C0.488663 6.36145 0.488662 7.63855 1.23323 8.54253C1.96564 9.43176 3.15032 10.7184 4.63728 11.7882C6.11832 12.8538 7.96326 13.75 10.0002 13.75C12.0371 13.75 13.882 12.8538 15.3631 11.7882C16.85 10.7184 18.0347 9.43176 18.7671 8.54253C19.5117 7.63855 19.5117 6.36145 18.7671 5.45747C18.0347 4.56824 16.85 3.28159 15.3631 2.21178C13.882 1.14624 12.0371 0.25 10.0002 0.25ZM2.39106 6.41111C3.07874 5.57619 4.17021 4.3957 5.51331 3.4294C6.86233 2.45883 8.40136 1.75 10.0002 1.75C11.599 1.75 13.138 2.45883 14.487 3.4294C15.8301 4.3957 16.9216 5.57619 17.6093 6.41111C17.8976 6.76118 17.8976 7.23882 17.6093 7.58889C16.9216 8.42381 15.8301 9.6043 14.487 10.5706C13.138 11.5412 11.599 12.25 10.0002 12.25C8.40136 12.25 6.86233 11.5412 5.51331 10.5706C4.17021 9.6043 3.07874 8.42381 2.39106 7.58889C2.10272 7.23882 2.10272 6.76118 2.39106 6.41111Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEye);
export default __webpack_public_path__ + "static/media/icn_eye.81692a6dec1e18b7f341d287bf088601.svg";
export { ForwardRef as ReactComponent };